import { jsx as _jsx } from "react/jsx-runtime";
import { FavoriteTrackingEventsContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/__internal__/FavoriteTrackingEventsContext";
import { useGetProductTileClickImpressions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import React from "react";
export var FavoriteTrackingEventsContextProviderBase = function(param) {
    var children = param.children, _param_data = param.data, productToken = _param_data.productToken, impressionId = _param_data.impressionId, promotedBy = _param_data.promotedBy;
    var _useGetProductTileClickImpressions = useGetProductTileClickImpressions({
        token: productToken,
        impressionId: impressionId,
        promotedBy: promotedBy
    }), recordHeartClickedEvent = _useGetProductTileClickImpressions.recordHeartClickedEvent, recordSaveToBoardSubmitEvent = _useGetProductTileClickImpressions.recordSaveToBoardSubmitEvent, recordRemoveFromBoardSubmitEvent = _useGetProductTileClickImpressions.recordRemoveFromBoardSubmitEvent;
    return /*#__PURE__*/ _jsx(FavoriteTrackingEventsContext.Provider, {
        value: {
            recordHeartClickedEvent: recordHeartClickedEvent,
            recordSaveToBoardSubmitEvent: recordSaveToBoardSubmitEvent,
            recordRemoveFromBoardSubmitEvent: recordRemoveFromBoardSubmitEvent
        },
        children: children
    });
};
